<div class="mt-3" *ngIf="loading">
  <span class="spinner-border spinner-border-sm me-2"></span>
  Cargando vista previa...
</div>

<div class="mt-3" *ngIf="!loading && report">

  <div class="table-responsive mb-3">
    <table class="table table-bordered table-sm align-middle">
      <thead class="table-light">
        <tr>
          <th>Descripción</th>
          <th class="text-end">Saldo Inicial</th>
          <th class="text-end">Ventas</th>
          <th class="text-end">Abonos</th>
          <th class="text-end">Saldo Final</th>
        </tr>
      </thead>

      <tbody>
        <tr class="table-secondary fw-bold">
          <td>Totales</td>
          <td class="text-end">{{ nz(report.totalBeginningBalance) | number:'1.2-2' }}</td>
          <td class="text-end">{{ nz(report.totalSales) | number:'1.2-2' }}</td>
          <td class="text-end">{{ nz(report.totalPayments) | number:'1.2-2' }}</td>
          <td class="text-end">{{ nz(report.totalEndingBalance) | number:'1.2-2' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="table-responsive">
    <table class="table table-bordered table-sm align-middle">
      <thead class="table-light">
        <tr>
          <th>Descripción</th>
          <th class="text-end">Saldo Inicial</th>
          <th class="text-end">Ventas</th>
          <th class="text-end">Abonos</th>
          <th class="text-end">Saldo Final</th>
        </tr>
      </thead>

      <tbody>
        <ng-container *ngFor="let place of report.subReports; trackBy: trackByPlace">

          <tr class="table-secondary fw-bold">
            <td>{{ place.placeName }}</td>
            <td class="text-end">{{ nz(place.totalBeginningBalancePlace) | number:'1.2-2' }}</td>
            <td class="text-end">{{ nz(place.totalSalesPlace) | number:'1.2-2' }}</td>
            <td class="text-end">{{ nz(place.totalPaymentsPlace) | number:'1.2-2' }}</td>
            <td class="text-end">{{ nz(place.totalEndingBalancePlace) | number:'1.2-2' }}</td>
          </tr>

          <tr *ngFor="let dest of place.destinations; trackBy: trackByDestination">
            <td class="ps-4">
              {{ dest.destinationName }}
            </td>
            <td class="text-end">{{ nz(dest.totalBeginningBalance) | number:'1.2-2' }}</td>
            <td class="text-end">{{ nz(dest.totalSales) | number:'1.2-2' }}</td>
            <td class="text-end">{{ nz(dest.totalPayments) | number:'1.2-2' }}</td>
            <td class="text-end">{{ nz(dest.totalEndingBalance) | number:'1.2-2' }}</td>
          </tr>

        </ng-container>
      </tbody>
    </table>
  </div>

</div>

<div class="mt-3 text-muted" *ngIf="!loading && !report">
  Presiona “Visualizar” para mostrar el reporte aquí.
</div>
